import { TestDefinition } from '@/modules/partner/model/test-definition';
import { get } from '@/shared/api/fetch-based-http-methods';
import { CountryCode, TCountryCodes } from '@/shared/models/country-code';
import { getApiUrl } from '@/shared/utils/getApiUrl';
import { w4dCitiesRemoteAPI } from '@src-common/api/definitions/w4d-cities-endpoints';
import {
  TCity as TRawCity,
  TDriverTest as TRawDriverTest,
} from '@src-common/api/definitions/w4d-city-types';
import { w4dPressureRemoteAPI } from '@src-common/api/definitions/w4d-pressure-endpoints';
import { createClient } from '@src-common/api/src/create-client';

import { ICity } from '../model/city';
import { Pressure } from '../model/pressure';

const citiesClient = createClient(w4dCitiesRemoteAPI({ apiHost: getApiUrl(), get }));
const pressureClient = createClient(w4dPressureRemoteAPI({ apiHost: getApiUrl(), get }));

const prepareTest = (testRaw: TRawDriverTest): TestDefinition => ({
  id: testRaw.id,
  description: testRaw.text_description ?? '',
  title: testRaw.text_title ?? '',
  localizedTitle: testRaw.title,
  localizedDescription: testRaw.body_driver,
  testType: testRaw.type,
  linkType: testRaw.link?.type ?? '',
  linkUrl: testRaw.link?.url ?? '',
  eLearningModuleLink: testRaw.e_learning_module_link ?? '',
});

const prepareCities = (cities: TRawCity[]): ICity[] => {
  const countryCodes = Object.values(CountryCode);

  return cities
    .filter(city => city.country_code && countryCodes.includes(city.country_code as any))
    .map(city => ({
      id: city.id,
      localizedName: city.localized_name,
      name: city.name,
      countryCode: city.country_code as TCountryCodes,
      testDefinitions: city?.driver_tests?.map(prepareTest) ?? [],
      timezone: city.timezone,
      currencyCode: city.currency,
      isEnabledForOnboarding: city.onboarding_enabled,
    }));
};

const commonAPI = {
  readCites: async () => {
    const response = await citiesClient.readCities();

    return prepareCities(Object.values(response.cities));
  },
  readPressure: async (): Promise<Pressure> => {
    const response = await pressureClient.readPressure();

    return response.pressure;
  },
};

export { commonAPI };
